/* eslint-disable max-len */
import moment from 'moment'
import some from 'lodash/some'
import sortBy from 'lodash/sortBy'
import orderBy from 'lodash/orderBy'

import { getExcludeVat } from '../../function/billing'

export const findMin = (data) => {
  let min = null
  data.map(d => {
    if (moment(d.delivery_date).isBefore(min) || !min) {
      min = d.delivery_date
    }
    return null
  })
  return min
}

export const findMax = (data) => {
  let max = null
  data.map(d => {
    const date = moment(d.delivery_date).add(d.credit_term, 'days')
    if (date.isAfter(max) || !max) {
      max = date
    }
    return null
  })
  return max
}

export const filterAP = (list, keywordSearch, apFilter) => {
  let _list = [...list]
  const { deliveryStartDate, deliveryEndDate, dueStartDate, dueEndDate, status } = apFilter
  const keyword = keywordSearch.toLowerCase()
  if (keyword !== '') {
    _list = _list.filter(item => {
      return (item.project_name && item.project_name.toLowerCase().includes(keyword))
          || (item.project_code && item.project_code.toLowerCase().includes(keyword))
          || (item.sub_project_code && item.sub_project_code.toLowerCase().includes(keyword))
          || (item.type && item.type.toLowerCase().includes(keyword))
          || (item.name && item.name.toLowerCase().includes(keyword))
          || (item.client_name && item.client_name.toLowerCase().includes(keyword))
    })
  }

  if (status !== 2) {
    _list = _list.filter(item => {
      let paying = {}
      if (item.hardware_id && item.accountant_paying_hardwares) {
        paying = item.accountant_paying_hardwares.find(h => h.hardware_id === item.hardware_id)
      } else if (item.license_id && item.accountant_paying_licenses) {
        paying = item.accountant_paying_licenses.find(l => l.license_id === item.license_id)
      } else if (item.vendor_id && item.accountant_paying_vendors) {
        paying = item.accountant_paying_vendors.find(v => v.vendor_id === item.vendor_id)
      }
      if (paying && status === 0) {
        return paying.status === 'UNPAID'
      } else if (paying && status === 1) {
        return paying.status === 'PAID'
      } return null
    })
  }

  if (deliveryStartDate || deliveryEndDate) {
    _list = _list.filter(item => {
      let paying = {}
      if (item.hardware_id && item.accountant_paying_hardwares) {
        paying = item.accountant_paying_hardwares.find(h => h.hardware_id === item.hardware_id)
      } else if (item.license_id && item.accountant_paying_licenses) {
        paying = item.accountant_paying_licenses.find(l => l.license_id === item.license_id)
      } else if (item.vendor_id && item.accountant_paying_vendors) {
        paying = item.accountant_paying_vendors.find(v => v.vendor_id === item.vendor_id)
      }
      if (paying) {
        const { partials = [] } = paying
        return some(partials, partial => {
          const start = deliveryStartDate ? moment(deliveryStartDate).format('YYYY-MM-DD') : null
          const end = deliveryEndDate ? moment(deliveryEndDate).format('YYYY-MM-DD') : null
          const deliveryDate = partial.delivery_date ? moment(partial.delivery_date).format('YYYY-MM-DD') : null
          if (deliveryStartDate && deliveryEndDate) {
            return moment(deliveryDate).isBetween(start, end, null, [])
          } else if (deliveryStartDate && !deliveryEndDate) {
            return moment(deliveryDate).isSame(start)
          } return moment(deliveryDate).isSame(end)
        })
      }
      return null
    })
  }

  if (dueStartDate || dueEndDate) {
    _list = _list.filter(item => {
      let paying = {}
      if (item.hardware_id && item.accountant_paying_hardwares) {
        paying = item.accountant_paying_hardwares.find(h => h.hardware_id === item.hardware_id)
      } else if (item.license_id && item.accountant_paying_licenses) {
        paying = item.accountant_paying_licenses.find(l => l.license_id === item.license_id)
      } else if (item.vendor_id && item.accountant_paying_vendors) {
        paying = item.accountant_paying_vendors.find(v => v.vendor_id === item.vendor_id)
      }
      if (paying) {
        const { partials = [] } = paying
        return some(partials, partial => {
          const start = dueStartDate ? moment(dueStartDate).format('YYYY-MM-DD') : null
          const end = dueEndDate ? moment(dueEndDate).format('YYYY-MM-DD') : null
          const dueDate = partial.delivery_date ? moment(partial.delivery_date).add(partial.credit_term, 'days').format('YYYY-MM-DD') : null
          if (dueStartDate && dueEndDate) {
            return moment(dueDate).isBetween(start, end, null, [])
          } else if (dueStartDate && !dueEndDate) {
            return moment(dueDate).isSame(start)
          } return moment(dueDate).isSame(end)
        })
      }
      return null
    })
  }

  return _list
}

export const filterAR = (list, keywordSearch, arFilter) => {
  let _list = [...list]
  const { dueStartDate, dueEndDate, status } = arFilter
  const keyword = keywordSearch.toLowerCase()

  if (keyword !== '') {
    _list = _list.filter(item => {
      return (item.project_name && item.project_name.toLowerCase().includes(keyword))
          || (item.project_code && item.project_code.toLowerCase().includes(keyword))
          || (item.sub_project_code && item.sub_project_code.toLowerCase().includes(keyword))
          || (item.type && item.type.toLowerCase().includes(keyword))
          || (item.name && item.name.toLowerCase().includes(keyword))
          || (item.client_name && item.client_name.toLowerCase().includes(keyword))
    })
  }

  _list = _list.filter(item => {
    if (status === 0) return item.status === 'PLANNING'
    else if (status === 1) return item.status === 'DELIVERED'
    else if (status === 2) return item.status === 'ISSUING'
    else if (status === 3) return item.status === 'INVOICED'
    else if (status === 4) return item.status === 'PAID'
    return item
  })

  if (dueStartDate || dueEndDate) {
    _list = _list.filter(item => {
      const start = dueStartDate ? moment(dueStartDate).format('YYYY-MM-DD') : null
      const end = dueEndDate ? moment(dueEndDate).format('YYYY-MM-DD') : null
      const dueDate = item.invoice_date ? moment(item.invoice_date).format('YYYY-MM-DD') : null
      if (dueStartDate && dueEndDate) {
        return moment(dueDate).isBetween(start, end, null, [])
      } else if (dueStartDate && !dueEndDate) {
        return moment(dueDate).isSame(start)
      } return moment(dueDate).isSame(end)
    })
  }

  return _list
}

export const sortAP = (list, sortOrder) => {
  const { col, desc } = sortOrder

  switch (col) {
    case 'cost': {
      return orderBy(list, 'cost', [desc ? 'desc' : 'asc'])
    }
    case 'updated': {
      const _list = sortBy(list, (item) => {
        const {
          accountant_paying_hardwares = [],
          accountant_paying_licenses = [],
          accountant_paying_vendors = [],
        } = item
        let partials = []

        if (item.hardware_id) {
          partials = accountant_paying_hardwares.find(h => h.hardware_id === item.hardware_id)
        } else if (item.license_id) {
          partials = accountant_paying_licenses.find(l => l.license_id === item.license_id)
        } else {
          partials = accountant_paying_vendors.find(v => v.vendor_id === item.vendor_id)
        }
        return partials ? moment(partials.updated) : null
      })
      return desc ? _list.reverse() : _list
    }
    case 'start_date': {
      const _list = sortBy(list, (item) => {
        const {
          accountant_paying_hardwares = [],
          accountant_paying_licenses = [],
          accountant_paying_vendors = [],
        } = item
        let partials = []

        if (item.hardware_id) {
          partials = accountant_paying_hardwares.find(h => h.hardware_id === item.hardware_id)
        } else if (item.license_id) {
          partials = accountant_paying_licenses.find(l => l.license_id === item.license_id)
        } else {
          partials = accountant_paying_vendors.find(v => v.vendor_id === item.vendor_id)
        }
        partials = partials ? partials.partials : []

        return findMin(partials)
      })
      return desc ? _list.reverse() : _list
    }
    case 'end_date': {
      const _list = sortBy(list, (item) => {
        const {
          accountant_paying_hardwares = [],
          accountant_paying_licenses = [],
          accountant_paying_vendors = [],
        } = item
        let partials = []

        if (item.hardware_id) {
          partials = accountant_paying_hardwares.find(h => h.hardware_id === item.hardware_id)
        } else if (item.license_id) {
          partials = accountant_paying_licenses.find(l => l.license_id === item.license_id)
        } else {
          partials = accountant_paying_vendors.find(v => v.vendor_id === item.vendor_id)
        }
        partials = partials ? partials.partials : []

        return findMax(partials)
      })
      return desc ? _list.reverse() : _list
    }
    default: return null
  }
}

export const sortAR = (list, sortOrder) => {
  const { col, desc } = sortOrder

  switch (col) {
    case 'exc_vat': {
      const _list = sortBy(list, item => parseFloat(getExcludeVat(item)))
      return desc ? _list.reverse() : _list
    }
    case 'updated': {
      const _list = sortBy(list, item => {
        const { accountant_billings = [], billing_id } = item
        const accountantBilling = accountant_billings.find(ab => ab.billing_id === billing_id)
        return accountantBilling
          && accountantBilling.updated
          && moment(accountantBilling.updated)
      })
      return desc ? _list.reverse() : _list
    }
    case 'invoice_date': {
      const _list = sortBy(list, item => moment(item.invoice_date))
      return desc ? _list.reverse() : _list
    }
    case 'cash_receive_date': {
      const _list = sortBy(list, item => {
        const { accountant_billings = [], billing_id } = item
        const accountantBilling = accountant_billings.find(ab => ab.billing_id === billing_id)
        return accountantBilling
        && accountantBilling.cash_receive_date
        && moment(accountantBilling.cash_receive_date)
      })
      return desc ? _list.reverse() : _list
    }
    default: return null
  }
}



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/function.js